@let view = mode() | modalMode: ModalMode.VIEW;
@let edit = mode() | modalMode: ModalMode.EDIT;
@let isGallerist = RolesDTO.ART_GALLERY | artHasRole;
<dx-modal
  height="content"
  width="xxl"
  label="{{ 'artwork.modal.title.artwork-details' | transloco }}"
  headingleveloverride="4"
  (modalClosed)="close()"
  [visible]="true"
>
  <div slot="content" [formGroup]="locationsForm">
    <dx-grid mq1="12/*">
      @if (edit) {
        <art-image-switch-area
          (uploadedImage)="uploadImage($event)"
          [altText]="manufacturerFullName()"
          [imageUrl]="imageUrl()"
          [(showDragAndDrop)]="showDragAndDrop"
          [imageError]="imageError()"
          [errorMessage]="'artwork.error-message.image' | transloco"
        ></art-image-switch-area>
      } @else {
        <art-bordered-image [uploadedImageUrl]="imageUrl()" [altText]="manufacturerFullName()"></art-bordered-image>
      }
      <div class="art-artwork-detail-headline">
        <dx-text type="h4" class="art-artwork-detail-title">{{ artworkMetaForm.value.title }}</dx-text>
        <dx-text type="pb" class="art-artwork-detail-artist">{{ manufacturerFullName() }}</dx-text>
      </div>
      <dx-accordion-group>
        <dx-accordion label="{{ 'artwork.accordion.stock-label' | transloco }}" headingleveloverride="4" open="true">
          <art-stock-location-price-form
            [stockLocationPriceForm]="locationsForm"
            mq4="6-(6)/*"
            [readonly]="view || edit || isGallerist"
          ></art-stock-location-price-form>
        </dx-accordion>
        <dx-accordion label="{{ 'artwork.accordion.price-label' | transloco }}" headingleveloverride="4">
          <art-stock-location-price-form
            [stockLocationPriceForm]="priceForm"
            mq4="2-2-2-2-4"
            [readonly]="view || edit || isGallerist"
          ></art-stock-location-price-form>
        </dx-accordion>
        <dx-accordion label="{{ 'artwork.accordion.metadata-label' | transloco }}" headingleveloverride="4">
          <art-artwork-meta-card
            [artworkMetaForm]="artworkMetaForm"
            [readonly]="view || edit || isGallerist"
            [showCustomFrame]="showCustomFrame()"
            [showCustomPassepartout]="showCustomPassepartout()"
          ></art-artwork-meta-card>
        </dx-accordion>
      </dx-accordion-group>
    </dx-grid>
  </div>

  <div slot="custom-actions" class="art-artwork-detail-action-buttons">
    @if (view) {
      <art-button
        shape="secondary"
        icon="edit"
        label="{{ 'artwork.button.edit-artwork' | transloco }}"
        (click)="editArtwork()"
      ></art-button>
      <div>
        <art-button shape="link" icon="gavel" label="{{ 'artwork.button.send-to-auction' | transloco }}"></art-button>
        <art-button shape="primary" icon="sell" label="{{ 'artwork.button.sell-artwork' | transloco }}"></art-button>
      </div>
    }
    @if (edit) {
      <dx-button
        type="primary-m"
        label="{{ 'artwork.button.save-artwork' | transloco }}"
        class="art-submit-button"
        (click)="saveEditedArtwork()"
        [loading]="isLoading()"
        [disabled]="
          this.isFormBlocked ||
          (this.locationsForm.pristine &&
            this.artworkMetaForm.pristine &&
            this.priceForm.pristine &&
            this.imageForm.pristine)
        "
      ></dx-button>
      <dx-button
        type="secondary-m"
        label="{{ 'artwork.button.cancel' | transloco }}"
        class="art-submit-button cancel-button"
        (click)="cancelEdit()"
      ></dx-button>
    }
  </div>
</dx-modal>
